/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.0
 */
import { createAction } from '../../../../../modules/app/createAction';
import {
    BASKET_CLEAN_LIST,
    BASKET_GET_LIST_FAILED,
    BASKET_GET_LIST_START,
    BASKET_GET_LIST_SUCCESSFUL,
    BASKET_SET_INIT_LIST,
    BASKET_SHOW_LOADER,
} from './basketConstants';
import {
    IBasketGetListStartPayload,
    IBasketGetListSuccessfulPayload, TBasketCleanListAction,
    TBasketGetListFailedAction,
    TBasketGetListStartAction,
    TBasketGetListSuccessfulAction,
    TBasketSetInitListAction,
    TBasketShowLoaderAction,
} from './basketTypes';

export const basketCleanListAction = (): TBasketCleanListAction =>
    createAction(BASKET_CLEAN_LIST);

export const basketGetListStart = (payload?: IBasketGetListStartPayload): TBasketGetListStartAction =>
    createAction(BASKET_GET_LIST_START, payload);

export const basketGetListSuccessful = (payload: IBasketGetListSuccessfulPayload): TBasketGetListSuccessfulAction =>
    createAction(BASKET_GET_LIST_SUCCESSFUL, payload);

export const basketGetListFailed = (): TBasketGetListFailedAction =>
    createAction(BASKET_GET_LIST_FAILED);

export const basketGetInitList = (payload: IBasketGetListSuccessfulPayload): TBasketSetInitListAction =>
    createAction(BASKET_SET_INIT_LIST, payload);

export const basketShowLoader = (): TBasketShowLoaderAction =>
    createAction(BASKET_SHOW_LOADER);
